<template>
  <div>
    <div
      v-if="backdrop"
      v-bind:class="backdropClass"
      v-on:click="onClickBackdrop"
      class="sc-confirmdialog-backdrop">
    </div>
    <div
      class="sc-confirmdialog-container"
      v-bind:class="additionalClass"
      v-bind:style="{ width: modalWidth + 'px' }">
      <div class="sc-confirmdialog-title-close-button">
        <div class="sc-confirmdialog-title">
          <slot name="title"></slot>
        </div>
        <span class="material-icons sc-confirmdialog-close-button" v-on:click="onClickClose">close</span>
      </div>
      <div
        class="sc-confirmdialog-text">
          <slot name="text"></slot>
      </div>
      <div class="sc-confirmdialog-confirm-reject-buttons">
        <slot name="buttons" v-bind="{ onReject, onConfirm }">
          <sc-gradient-action-button
            variant="outline"
            class="sc-confirmdialog-reject-button sc-confirmdialog-decide-buttons"
            v-on:click="onReject">
              {{ cancelLabel }}
          </sc-gradient-action-button>
          <sc-gradient-action-button
            class="sc-confirmdialog-confirm-button sc-confirmdialog-decide-buttons"
            v-on:click="onConfirm">
              {{ okLabel }}
          </sc-gradient-action-button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import ScGradientActionButton from './ScGradientActionButtonComponent'

export default {
  name: 'ScConfirmDialog',
  components: {
    ScGradientActionButton
  },
  props: {
    backdrop: {
      type: Boolean,
      default: false
    },
    closeOnBackdropClick: {
      type: Boolean,
      default: true
    },
    additionalClass: {
      type: String
    },
    backdropClass: {
      type: String
    },
    cancelLabel: {
      type: String,
      default: 'Cancel'
    },
    okLabel: {
      type: String,
      default: 'OK'
    },
    width: {
      type: Number,
      default: 550
    }
  },
  data () {
    return {
      modalWidth: 0,
      modalMargin: 20
    }
  },
  mounted () {
    this.getWindowMeasures()
  },
  methods: {
    getWindowMeasures () {
      this.$nextTick(() => {
        this.getWindowWidth()
        window.addEventListener('resize', () => {
          this.getWindowWidth()
        })
      })
    },
    getWindowWidth () {
      this.windowWidth = window.innerWidth
      this.setModalWidth()
    },
    setModalWidth () {
      if (this.width > this.windowWidth - this.modalMargin) {
        this.modalWidth = this.windowWidth - this.modalMargin
      } else {
        this.modalWidth = this.width
      }
    },
    onReject () {
      this.$emit('cancel')
    },
    onConfirm () {
      this.$emit('ok')
    },
    onClickClose () {
      this.$emit('close')
    },
    onClickBackdrop () {
      if (this.closeOnBackdropClick) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sc-confirmdialog-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $sc-confirmdialog-backdrop-color;
  z-index: 9999;
}
.sc-confirmdialog-container {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid $sc-confirmdialog-border-color;
  padding: $sc-confirmdialog-paddig;
  color: $sc-confirmdialog-color;
  position: fixed;
  background-color: $sc-confirmdialog-light-bg;
  z-index: 10000;
}
.sc-confirmdialog-close-button {
  font-size: $sc-confirmdialog-close-button-icon-size;
  top: 0%;
  right: 0%;
  float: right;
  cursor: pointer;
}
.sc-confirmdialog-title {
  width: 100%;
  text-align: left;
  font-weight: 600;
  font-size: $sc-confirmdialog-title-font-size;
}
.sc-confirmdialog-title-close-button {
  display: flex;
}
.sc-confirmdialog-text {
  width: 100%;
  text-align: left;
  margin: $sc-confirmdialog-text-margin;
}
.sc-confirmdialog-confirm-reject-buttons {
  display: flex;
}
.sc-confirmdialog-decide-buttons {
  text-align: center;
  border: 1px solid $sc-primary;
  margin-top: $sc-confirmdialog-decide-buttons-margin-top;
  padding: $sc-confirmdialog-decide-buttons-padding;
  cursor: pointer;
}
.sc-confirmdialog-reject-button {
  margin-right: $sc-confirmdialog-decide-buttons-margin;
  color: $sc-primary;
  background-color: $sc-confirmdialog-light-bg;
}
.sc-confirmdialog-confirm-button {
  margin-left: $sc-confirmdialog-decide-buttons-margin;
  color: $sc-primary-light;
  background-color: $sc-primary;
}
</style>
